import { ReactComponent as Chart } from "@assets/icons/chart_icon.svg";

const ChartIcon = (props: any): JSX.Element => {
  return (
    <Chart
      fill={props?.sx?.color || props?.sx?.fill}
      height={props?.sx?.height || "16px"}
      width={props?.sx?.width || props?.sx?.height || "16px"}
      {...props}
    />
  );
};

export default ChartIcon;
